<template>
	<div class="main-modal">
		<button :class="buttonClass" @click="showModal($event, true)" v-if="!hide_button">{{button_content}}</button>
		<transition name="main-modal" v-on:leave="leaving = true" v-on:after-leave="fullyClosed">
			<div class="main-modal--container" v-show="is_open" @click="closeModal">
				<div class="main-modal--container-inner">
					<div class="main-modal--container-inner-header">
						<h3 class="text-center">{{title}}</h3>
						<a class="main-modal--container-inner-header-close" v-if="show_close_button" @click="showModal($event, true)"></a>
					</div>
					<slot class="main-modal--container-inner-body">
					</slot>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		props: [
			'title',
			'show_close_button',
			'on_blur_close',
			'button_class',
			'button_label',
			'button_small',
			'button_content',
			'hide_button',
            'triggersFrom'
		],
		data(){
			return {
				is_open: false,
				leaving: false,
				left: true,
			}
		},
		mounted() {
			this.$on('child_close', () => {
                this.is_open = true;
				this.showModal(null, true);
			});

            if(this.triggersFrom != undefined){
                $(this.triggersFrom).click((e) => {
                    if(this.is_open){
                        this.closeModal(e, true);
                    } else {
                        this.showModal(e, true);
                    }
                });
            }
		},
		computed: {
			buttonClass() {
				return this.button_class ? this.button_class : 'btn btn-sm btn-primary';
			}
		},
		methods: {
			closeModal(e = null, force = false){
				if(e != null){
					if($(e.target).hasClass('main-modal--container') || force){
                        e.preventDefault();
                        this.$emit('closing');
						$('body').removeClass('main-modal--noscroll');
						this.is_open = false;
					}
				} else {
					this.$emit('closing');
					$('body').removeClass('main-modal--noscroll');
					this.is_open = false;
				}
			},
			showModal(e, force = false) {
				e.preventDefault();

				if (!force){
					if ($(e.target).closest('.main-modal--container-inner').length){
						return;
					}
					if (this.leaving){
						return;
					}
				}

				this.left = false;

				if(this.is_open){
					this.$emit('closing');
					$('body').removeClass('main-modal--noscroll');
				} else {
					//the remove makes sure two modals can be triggered
					$('body').removeClass('main-modal--noscroll').addClass('main-modal--noscroll');
				}

				this.is_open = !this.is_open;
			},

			fullyClosed(){
				this.left = true;
				this.leaving = false;
				this.$emit('closed');
			}
		}
	}
</script>
